import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Attendee } from '../types';

export type AuthState = {
    token: string | null,
    user: Attendee | null,
};

const initialState: AuthState = {
    token: null,
    user: null,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        authLogin: (state, action: PayloadAction<AuthState>) => {
            state.token = action.payload.token;
            state.user = action.payload.user;
        },
        authLogout: (state) => {
            state.token = null;
            state.user = null;
        },
        authUpdateUser: (state, action: PayloadAction<Attendee>) => {
            state.user = action.payload;
        },
        authUpdateUserCategories: (state, action: PayloadAction<number[]>) => {
            if(state.user) state.user.categories = action.payload;
        },
        authUpdateUserAvatar: (state, action: PayloadAction<number|null>) => {
            if(state.user) state.user.avatar = action.payload;
        },
    }
});

export const {
    authLogin,
    authLogout,
    authUpdateUser,
    authUpdateUserCategories,
    authUpdateUserAvatar } = authSlice.actions;
export default authSlice.reducer;
